"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx } from "react/jsx-runtime";
import React from "react";
import _ from "underscore";
import classNames from "classnames";
import { cleanReferenceValue } from "../helpers/references";
class HoverableValue extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", { hovered: false });
    __publicField(this, "valueEntered", (value) => {
      if (this.props.onValueHighlighted) this.props.onValueHighlighted(value);
      this.setState({ hovered: true });
    });
    __publicField(this, "valueLeft", () => {
      if (this.props.onValueHighlighted) this.props.onValueHighlighted(void 0);
      this.setState({ hovered: false });
    });
    __publicField(this, "valueClicked", (value) => {
      if (this.props.onValueClick) this.props.onValueClick(value);
    });
  }
  render() {
    if (_.isEmpty(this.props.value)) {
      return null;
    }
    const value = cleanReferenceValue(this.props.value);
    const classes = classNames({
      "hoverable-value-table__value": true,
      "hoverable-value-table__value--selected": this.state.hovered
    });
    return /* @__PURE__ */ jsx(
      "span",
      {
        onMouseEnter: () => this.valueEntered(value),
        onMouseLeave: this.valueLeft,
        onClick: () => this.valueClicked(value),
        className: classes,
        children: value
      }
    );
  }
}
export default HoverableValue;
